import InfoIcon from '@mui/icons-material/Info'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import type { GridRenderCellParams } from '@mui/x-data-grid'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath, Link } from 'react-router-dom'

// Update these constants to match your routes
const LAYOUT_DEFAULT = '/'
const RT_DEVICE_INFO = 'v2/main/device/:uid'

interface DeviceInfoButtonProps {
  params: GridRenderCellParams
}

const DeviceInfoButton: React.FC<DeviceInfoButtonProps> = ({ params }) => {
  const { t } = useTranslation('common')

  const { uid } = params.row

  const deviceInfoPath = generatePath(LAYOUT_DEFAULT + RT_DEVICE_INFO, {
    uid,
  })

  return (
    <Tooltip title={t('common:general.info')}>
      <Link
        to={deviceInfoPath}
        onClick={(e) => {
          // Prevent the DataGrid row selection
          e.stopPropagation()
        }}
        style={{ textDecoration: 'none' }}
      >
        <IconButton
          data-testid={`device-info-button-${uid}`}
          size="small"
          aria-label={t('general.info')}
          sx={{
            bgcolor: '#9c27b0',
            color: 'white',
            width: '32px',
            height: '32px',
            minWidth: '32px',
            minHeight: '32px',
            '&:hover': {
              bgcolor: '#7b1fa2',
            },
          }}
        >
          <InfoIcon fontSize="small" />
        </IconButton>
      </Link>
    </Tooltip>
  )
}

export default DeviceInfoButton
